export const GET_PAID_LEAVE_APPROVAL = '/paid_leave_approval/';
export const PAID_LEAVE_APPROVAL_ID = id => `/paid_leave_approval/${id}/`;
